import Main from "./variants/Main";
import New from "./variants/New";
import Edit from "./variants/Edit";

export default {
  Main,
  New,
  Edit
}